import React, { createContext, useReducer } from 'react';

export const Context = createContext();

export const initialState = JSON.parse(localStorage.getItem('copy-user')) || {
  userImg: '',
  username: '',
  email: '',
  logged: false,
  token: '',
  globalColor: '',
  location: {},
};

export const Store = (props) => {
  function reducer(state, action) {
    switch (action.type) {
      case 'SET_LOCATION':
        localStorage.setItem(
          'copy-user',
          JSON.stringify({
            ...state,
            location: action.payload,
          }),
        );
        return {
          ...state,
          location: action.payload,
        };
      case 'SET_USER_DATA':
        localStorage.setItem(
          'copy-user',
          JSON.stringify({
            ...state,
            ...action.payload,
            globalColor: state.globalColor,
          }),
        );
        return {
          ...state,
          ...action.payload,
          globalColor: state.globalColor,
        };
      case 'USER_LOGIN':
        localStorage.setItem(
          'copy-user',
          JSON.stringify({
            ...action.payload,
            logged: true,
            token: action.payload.token,
          }),
        );
        return {
          ...state,
          ...action.payload,
          logged: true,
        };
      case 'USER_COLOR':
        return { ...state, globalColor: action.payload };
      case 'USER_LOGOUT':
        localStorage.removeItem('copy-user');
        return { ...state, logged: false };
      default:
        return state;
    }
  }
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <Context.Provider value={{ state, dispatch }}>
      {props.children}
    </Context.Provider>
  );
};
